import { render, staticRenderFns } from "./CustomFormDetail.vue?vue&type=template&id=6d0751c9"
import script from "./CustomFormDetail.vue?vue&type=script&lang=js"
export * from "./CustomFormDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports